export default "__VITE_ASSET__C3Ga8Nmq__"